import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListCheck3Line = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 13C8.05436 13 8.91817 13.8159 8.99451 14.8507L9 15V18C9 19.0544 8.18412 19.9182 7.14926 19.9945L7 20H4C2.94564 20 2.08183 19.1841 2.00549 18.1493L2 18V15C2 13.9456 2.81588 13.0818 3.85074 13.0055L4 13H7ZM16 17C16.5523 17 17 17.4477 17 18C17 18.5128 16.614 18.9355 16.1166 18.9933L16 19H12C11.4477 19 11 18.5523 11 18C11 17.4872 11.386 17.0645 11.8834 17.0067L12 17H16ZM7 15H4V18H7V15ZM20 13C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15H12C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13H20ZM7 3C8.10457 3 9 3.89543 9 5V8C9 9.10457 8.10457 10 7 10H4C2.89543 10 2 9.10457 2 8V5C2 3.89543 2.89543 3 4 3H7ZM16 7C16.5523 7 17 7.44772 17 8C17 8.51283 16.614 8.93551 16.1166 8.99327L16 9H12C11.4477 9 11 8.55228 11 8C11 7.48717 11.386 7.06449 11.8834 7.00673L12 7H16ZM7 5H4V8H7V5ZM20 3C20.5523 3 21 3.44772 21 4C21 4.51283 20.614 4.93551 20.1166 4.99327L20 5H12C11.4477 5 11 4.55228 11 4C11 3.48717 11.386 3.06449 11.8834 3.00673L12 3H20Z"
	})
});
export default SvgListCheck3Line;
